function e(){return!!/Firefox\/([0-9.]+)(?:\s|$)/.exec(window.navigator.userAgent)}export{e as isFirefox};
//# sourceMappingURL=user-agent-utils.js.map
